import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const FinanceTaxRoutes = defineRoute({
    record: {
        route: {
            path: "/finance-tax",
            component: () => loadView(import("./FinanceTaxTable.vue")),
        },
    },
    detail: {
        route: {
            path: "/finance-tax/detail/:id",
            component: () => loadView(import("./FinanceTaxDetail.vue")),
        },
        build(id: string) {
            return `/finance-tax/detail/${id}`;
        },
    },
});
